<template>
  <div class="page_table_area unit">
    <!-- 单位类型 -->
    <div class="tab_area">
      <el-tabs v-model="activeTabId">
        <el-tab-pane
          :label="item.name"
          :name="item.id"
          v-for="(item, index) in arrUnitTypes"
          :key="index"
          >{{ item.name }}</el-tab-pane
        >
      </el-tabs>
    </div>
    
    <div class="scroll_area">
      <!-- 标题 -->
    <div class="table_title_area">
      <div class="left">
        合计：<span class="blue">{{ pageData.total }}条</span>
      </div>
      <el-button
        class="btn_create right"
        @click="btnCreateClick"
        v-if="pms.create"
      >
        <div class="btn_content">
          <div class="icon-create"></div>
          <div class="text_create">新建</div>
        </div>
      </el-button>
    </div>
    <!-- 表格 -->
    <div class="table_area">
      <el-table :data="tableData">
        <el-table-column :width="7 * docFontSize"></el-table-column>
        <el-table-column
          label="创建日期"
          prop="createTime"
          :width="22 * docFontSize"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime  }}
          </template>
        </el-table-column>
        <el-table-column
          label="省份"
          prop="provinceStr"
          :width="11.7 * docFontSize"
        ></el-table-column>
        <el-table-column
          label="城市"
          prop="cityStr"
          :width="12.8 * docFontSize"
        ></el-table-column>
        <el-table-column
          label="单位全称"
          prop="appName"
          :width="21.8 * docFontSize"
        ></el-table-column>
        <el-table-column
          label="单位编号"
          prop="appCode"
          :width="32.1 * docFontSize"
        ></el-table-column>
        <el-table-column
          label="单位简称"
          prop="appShortName"
          :width="25.6 * docFontSize"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope" v-if="scope.row.createTime">
            <el-button
              type="text"
              @click="btnEditClick(scope.row)"
              v-if="pms.edit"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="btnDetailClick(scope.row)"
              v-if="pms.detail"
              >详情</el-button
            >
            <el-button
              type="text"
              style="color: #ff4a24"
              @click="btnDeleteClick(scope.row)"
              v-if="pms.delete"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <table-empty></table-empty>
        </template>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination_area">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageData.page"
        :page-sizes="[20, 50, 100]"
        :page-size="pageData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageData.total"
      >
      </el-pagination>
    </div>
    </div>

    <!-- 新建 -->
    <el-dialog
      :title="createData.id ? '编辑' : '新建'"
      :visible.sync="showCreateDialog"
      width="61rem"
      :before-close="handleDialogClose"
      :close-on-click-modal="false"
      class="dialog_unit_create partI"
    >
      <el-form
        :model="createData"
        ref="formCreateUnit"
        label-width="25rem"
        :rules="createRules"
      >
        <el-form-item prop="province" label="省份：">
          <el-select
            v-model="createData.province"
            placeholder="请选择"
            @change="selectProvinceChange"
          >
            <el-option
              v-for="item in arrAllProvince"
              :key="item.areaId"
              :label="item.areaName"
              :value="item.areaId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="city" label="城市：">
          <el-select
            v-model="createData.city"
            placeholder="请选择"
            :disabled="createData.province == ''"
          >
            <el-option
              v-for="item in arrAllCity"
              :key="item.areaId"
              :label="item.areaName"
              :value="item.areaId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="appName" label="单位全称：">
          <el-input
            v-model.trim="createData.appName"
            placeholder="请输入单位全称"
            maxlength="30"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="appShortName" label="单位简称：">
          <el-input
            v-model.trim="createData.appShortName"
            placeholder="请输入单位简称"
            maxlength="10"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCreateDialog = false">取消</el-button>
        <el-button type="primary" @click="btnDoneCreateClick">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TableEmpty from "../../../../components/TableEmpty.vue";
import mixins from "./Mixins";
export default {
  components: { TableEmpty },
  mixins: [mixins],
  data() {
    return {
      pms: {
        create: false,
        delete: false,
        edit: false,
        detail: false,
      },
      showCreateDialog: false,
      arrAllProvince: [],
      arrAllCity: [],
      createRules: {
        province: [{ required: true, message: "请选择省份", trigger: "blur" }],
        city: [{ required: true, message: "请选择城市", trigger: "blur" }],
        appName: [
          { required: true, message: "请输入单位全称", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "请输入2-30位的单位全称",
            trigger: "blur",
          },
        ],
        appShortName: [
          { required: true, message: "请输入单位简称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "请输入2-10位的单位简称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    arrUnitTypes() {
      return this.Unit.arrUnitTypes;
    },
    activeTabId: {
      get() {
        return this.Unit.activeTabId;
      },
      set(v) {
        this.SETOPTIONS({ activeTabId: v });
      },
    },
    tableData() {
      return this.Unit.tableData;
    },
    pageData() {
      return this.Unit.pageData;
    },
    showDetailDrawer: {
      get() {
        return this.Unit.showDetailDrawer;
      },
      set(v) {
        this.SETOPTIONS({
          showDetailDrawer: v,
        });
      },
    },
    createData() {
      return this.Unit.createData;
    },
  },
  filters: {
    filterCreateDate(v) {
      if (v && v.indexOf(" ") >= 0) {
        return v.split(" ")[0];
      } else {
        return "";
      }
    },
  },
  watch: {
    activeTabId() {
      this.SETOPTIONS({
        pageData: {
          page: 1,
          total: 0,
          size: 20,
        },
      });
      this.getTableList_A();
    },
  },
  created() {
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms.create = pms["20200"].check;
    this.pms.delete = pms["20300"].check;
    this.pms.edit = pms["20404"].check;
    this.pms.detail = pms["20500"].check;
  },
  async mounted() {
    this.arrAllProvince = await this.getProvinceOrCity_A({
      parentId: 1,
      query: false,
    });
  },
  methods: {
    handleSizeChange() {
      this.getTableList_A();
    },
    handleCurrentChange() {
      this.getTableList_A();
    },
    handleDrawerClose() {
      this.showDetailDrawer = false;
      this.SETOPTIONS({});
    },
    btnCreateClick() {
      if (this.$refs.formCreateUnit) {
        this.$refs.formCreateUnit.clearValidate();
      }

      this.SETOPTIONS({
        createData: {
          id: "",
          province: "",
          city: "",
          appName: "",
          appShortName: "",
          type: this.activeTabId,
        },
      });
      this.showCreateDialog = true;
    },
    async btnEditClick(row) {
      if (this.$refs.formCreateUnit) {
        this.$refs.formCreateUnit.clearValidate();
      }
      let arrCitys = await this.getProvinceOrCity_A({
        parentId: row.province,
        query: false,
      });
      this.arrAllCity = arrCitys;
      this.SETOPTIONS({
        createData: {
          id: row.appId,
          province: row.province,
          city: row.city,
          appName: row.appName,
          appShortName: row.appShortName,
          type: this.activeTabId,
        },
      });
      this.showCreateDialog = true;
    },
    handleDialogClose() {
      this.SETOPTIONS({
        createData: {
          id: "",
          province: "",
          city: "",
          appName: "",
          appShortName: "",
        },
      });
      this.showCreateDialog = false;
      if (this.$refs.formCreateUnit) {
        this.$refs.formCreateUnit.clearValidate();
      }
    },
    async selectProvinceChange() {
      this.setCreateData_M({
        city: "",
      });
      if (this.createData.province != "") {
        let arrCitys = await this.getProvinceOrCity_A({
          parentId: this.createData.province,
          query: false,
        });
        this.arrAllCity = arrCitys;
      }
    },
    btnDoneCreateClick() {
      this.$refs.formCreateUnit.validate(async (res) => {
        if (res) {
          if (this.createData.id) {
            let result = await this.doCreateEditDelete_A({
              appId: this.createData.id,
              province: this.createData.province,
              city: this.createData.city,
              appName: this.createData.appName,
              appShortName: this.createData.appShortName,
              type: this.activeTabId,
            });
            if (result) {
              this.showCreateDialog = false;
              this.getTableList_A();
              this.$Message.success("编辑成功")
            }
          } else {
            let result = await this.doCreateEditDelete_A({
              province: this.createData.province,
              city: this.createData.city,
              appName: this.createData.appName,
              appShortName: this.createData.appShortName,
              type: this.activeTabId,
            });
            if (result) {
              this.SETOPTIONS({
                pageData: {
                  page: 1,
                  size: this.pageData.size,
                  total: 0,
                },
              });
              this.showCreateDialog = false;
              this.getTableList_A();
              this.$Message.success("新建成功")

            }
          }
        }
      });
    },
    // // 更新省份搜索条件
    // refreshProvince() {
    //   let arrProvinces = await this.getProvinceOrCity_A({
    //   parentId: 1,
    //   query: true,
    // });
    // let total = {
    //   areaId: "",
    //   areaName: "全部",
    //   areaPinyin: "quan bu",
    //   fileName: "",
    //   parentId: 1,
    //   state: 1,
    // };
    // arrProvinces.unshift(total);
    // this.arrProvinces = arrProvinces;
    // },
    // 删除
    btnDeleteClick(row) {
      this.$Confirm("信息删除后将无法恢复，确定要删除该信息吗？", "提示", {
        type: "warning",
        customClass: "partI",
        closeOnClickModal:false
      })
        .then(async () => {
          let result = await this.doCreateEditDelete_A({
            appId: row.appId,
            isDel: true,
            type: this.activeTabId,
          });
          if (result) {
            this.$Message.error("删除成功")
            this.showCreateDialog = false;
            this.getTableList_A();
          }
        })
        .catch(() => {});
    },
    // 详情
    btnDetailClick(row) {
      this.SETOPTIONS({
        detailAppId: row.appId,
        detailCurrentTabId: 1,
        appDetail: {},
        appStatistics: {
          amUseCount: 0,
          amUseCountUp: 0,
          dmCreateCount: 0,
          dmCreateCountUp: 0,
          dmVisitRelationCount: 0,
          dmVisitRelationCountUp: 0,
        },
        detailPageData: {
          page: 1,
          total: 0,
          size: 20,
        },
        hallTableData: [],
        ceremoryTableData: [],
        accountTableData: [],
      });
      this.getCeremonyList_A();
      this.getUnitDetailWithId_A();
      this.getUnitStatisticsWithId_A();
      this.SETOPTIONS({
        showDetailDrawer: true,
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.page_table_area.unit {
  top: 182px;

  .tab_area {
    height: 69px;
    margin: 0 30px;
    border-bottom: 1px solid #CCD7EA;
  }
   .scroll_area {
        position:absolute;
        left:0;
        bottom :0;
        right :0;
        top:70px;
        overflow-y: overlay;
    }
}

.dialog_unit_create {
  .el-button {
    width: 100px;
    height: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PartI/UnitManagement/components/unitTable.vue